import { render, staticRenderFns } from "./ArmyMound.vue?vue&type=template&id=f4b6ca4a&"
import script from "./ArmyMound.vue?vue&type=script&lang=js&"
export * from "./ArmyMound.vue?vue&type=script&lang=js&"
import style0 from "./ArmyMound.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArmyMound.vue"
export default component.exports